// ── V146: 지금 보고 있는 셈핏 버전 + '새 버전 확인' ─────────────────────────────
import React, { useState } from 'react';
import { useLang } from '../i18n/LangContext';
import { APP_VERSION, APP_DATE, swVersionNumber, appVersionNumber } from '../version';

export default function VersionCheck() {
  const { lang } = useLang();
  const L = (ko, zh) => (lang === 'zh' ? zh : ko);
  const [state, setState] = useState({ s: 'idle' });   // idle | checking | latest | new | fail

  const check = async () => {
    setState({ s: 'checking' });
    try {
      const res = await fetch(`/service-worker.js?check=${Date.now()}`, { cache: 'no-store' });
      const n = swVersionNumber(await res.text());
      if (!n) throw new Error('no version');
      // 받아 둔 새 버전도 같이 확인해 둔다 (새로고침하면 바로 적용되게)
      try {
        const reg = navigator.serviceWorker && await navigator.serviceWorker.getRegistration();
        if (reg) await reg.update();
      } catch (e) { /* 무시 */ }
      setState(n > appVersionNumber() ? { s: 'new', n } : { s: 'latest' });
    } catch (e) {
      setState({ s: 'fail' });
    }
  };

  return (
    <div data-version-check>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <div style={{ fontSize: 15, color: '#18181B' }}>
          {L('지금 보고 있는 버전', '当前版本')} <strong data-app-version style={{ fontSize: 18 }}>{APP_VERSION}</strong>
          <span style={{ fontSize: 12, color: '#71717A', marginLeft: 6 }}>({APP_DATE})</span>
        </div>
        <button type="button" data-version-btn onClick={check} disabled={state.s === 'checking'}
          style={{ marginLeft: 'auto', padding: '7px 12px', borderRadius: 8, border: '1px solid #D4D4D8', background: '#fff',
                   fontSize: 13, fontWeight: 700, cursor: state.s === 'checking' ? 'default' : 'pointer', color: '#18181B' }}>
          {state.s === 'checking' ? L('확인 중…', '检查中…') : L('🔄 새 버전 확인', '🔄 检查新版本')}
        </button>
      </div>
      {state.s === 'latest' && (
        <div data-version-result="latest" style={{ marginTop: 8, fontSize: 13, color: '#15803D', fontWeight: 700 }}>
          {L('✓ 최신 버전이에요', '✓ 已是最新版本')}
        </div>
      )}
      {state.s === 'new' && (
        <div data-version-result="new" style={{ marginTop: 8, padding: '10px 12px', borderRadius: 8, background: '#FFF7ED',
                                                border: '1px solid #FDBA74', fontSize: 13, color: '#9A3412', lineHeight: 1.5 }}>
          {L(`새 버전 V${state.n}이 나왔어요. 발주서를 작성 중이면 먼저 저장·전송한 뒤 새로고침하세요.`,
             `有新版本 V${state.n}。正在填写订货单的话，请先保存或发送，再刷新。`)}
          <button type="button" data-version-reload onClick={() => window.location.reload()}
            style={{ marginLeft: 8, padding: '5px 12px', borderRadius: 8, border: 'none', background: '#FF6F0F', color: '#fff',
                     fontSize: 13, fontWeight: 800, cursor: 'pointer' }}>
            {L('새로고침', '刷新')}
          </button>
        </div>
      )}
      {state.s === 'fail' && (
        <div data-version-result="fail" style={{ marginTop: 8, fontSize: 13, color: '#B91C1C' }}>
          {L('확인하지 못했어요. 인터넷 연결을 확인해 주세요.', '无法检查，请确认网络连接。')}
        </div>
      )}
      <div style={{ marginTop: 8, fontSize: 12, color: '#71717A', lineHeight: 1.5 }}>
        {L('고친 기능이 그대로면 버전부터 확인하세요. 화면을 켜 둔 채로는 새 버전이 적용되지 않아요.',
           '如果修好的功能还没变，先看版本号。页面一直开着的话，新版本不会自动生效。')}
      </div>
    </div>
  );
}
